import { Injectable, inject } from '@angular/core';

import {environment} from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import {User} from '../_interfaces/user';
import {skipModalError} from '../_models/auth';
import {map} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DomainConfigService {
  private http = inject(HttpClient);


  private domainConfigUrl = `${environment.newApiUrl}/domain/config`;

  private _userSubaccountConfig = new BehaviorSubject<User.SubaccountConfig>(null);
  readonly userSubaccountConfig = this._userSubaccountConfig.asObservable();

  public getConfig(domain_name: string){
    return this
      .http.get< {config: User.SubaccountConfig}>(
        this.domainConfigUrl, {
          params: {
            domain_name
          },
          context: skipModalError(['all'])
        }
      )
      .pipe(
        map(config => ({
          ...config.config,
            custom: true
        }))
      );
  }

  public setUserSubaccountConfig(config: User.SubaccountConfig){
    this._userSubaccountConfig.next(config);
  }

}
